export default __webpack_public_path__ + "static/media/alisuq_story.1ef6270e.jpg";